module.exports = __webpack_public_path__ + "img/huge-table.dd26ab9a.png";